import { Component, OnDestroy, PLATFORM_ID, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

import { Store } from '@ngrx/store';
import { Observable, Subscription, filter } from 'rxjs';

import { NavigationMenuService, ScrollService } from '@fcom/common/services';
import { ConfigService } from '@fcom/core';
import { LanguageActions } from '@fcom/core/actions';
import { AppState } from '@fcom/core/interfaces';
import { unsubscribe } from '@fcom/core/utils';
import { isNavigationEvent } from '@fcom/common/utils';
import { LanguageService } from '@fcom/ui-translate';

@Component({
  selector: 'fin-language-setting-layout',
  templateUrl: './language-setting-layout.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LanguageSettingLayoutComponent implements OnDestroy {
  private navigationMenuService = inject(NavigationMenuService);
  private router = inject(Router);
  private scrollService = inject(ScrollService);
  private platform = inject(PLATFORM_ID);
  private store$ = inject<Store<AppState>>(Store);
  private configService = inject(ConfigService);

  subscriptions: Subscription = new Subscription();
  isFooterOpen$: Observable<boolean>;

  constructor() {
    if (isPlatformServer(this.platform)) {
      this.store$.dispatch(
        LanguageActions.setLanguage({
          language: LanguageService.FALLBACK_LANGUAGE,
          locale: this.configService.cfg.allowedLocales[LanguageService.FALLBACK_LANGUAGE],
        })
      );
    }

    this.subscriptions.add(
      this.router.events
        .pipe(
          filter(isNavigationEvent),
          filter(() => isPlatformBrowser(this.platform))
        )
        .subscribe(() => {
          this.scrollService.scrollTop();
        })
    );
    this.isFooterOpen$ = this.navigationMenuService.isFooterOpen$;
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }
}
